module.exports = __webpack_public_path__ + "static/media/custom-water-feature.ade06bca.jpeg";